module.exports = __webpack_public_path__ + "static/media/trusted-shops-logo.f5ab2f4c.png";